<template>
  <div>
    <AppNavbar />
    <div class="support-page-root">
      <div class="content-full-bleed-row">
        <section class="support-section">
          <div class="support-wrapper">
            <div class="support-block reveal">
              <h1>Support</h1>
              <p class="support-text">
                For any queries or assistance, please write to us at
                <a href="mailto:customercare@indiekonnect.com"
                  >support@indiekonnect.com
                </a>
                , or call us at
                <a href="tel:+918054540153">+918054540153</a>.
              </p>
              <p class="support-highlight">
                Support Hours: 10:00 AM - 10:00 PM, daily. Languages: Hindi and
                English.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
    <FooterView />
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import AppNavbar from "../AppNavbar.vue";
import FooterView from "../FooterView.vue";

onMounted(() => {
  const body = document.body;
  if (body) {
    body.style.setProperty("margin", "0", "important");
    body.style.setProperty("padding", "0", "important");
    body.style.setProperty("max-width", "100%", "important");
  }

  const revealElements = document.querySelectorAll(".reveal");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        }
      });
    },
    { threshold: 0.08 },
  );
  revealElements.forEach((el) => observer.observe(el));
});
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700;800&display=swap");

* {
  box-sizing: border-box;
}

.support-page-root {
  width: 100vw !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  font-family: "Raleway", sans-serif;
  background: #f7f9fc;
  color: #333f48;
  overflow-x: hidden;
}

.content-full-bleed-row {
  width: 100% !important;
  background: #f7f9fc;
  display: block;
}

.support-section {
  width: 100% !important;
  padding: 60px 0;
}

.support-wrapper {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 24px;
}

.support-block h1 {
  font-size: 34px;
  color: #003da5;
  margin-bottom: 16px;
  font-weight: 800;
}

.support-text {
  font-size: 16px;
  line-height: 1.9;
  color: #4c5661;
}

.support-text a {
  color: #003da5;
  font-weight: 700;
  text-decoration: underline;
}

.support-highlight {
  margin-top: 16px;
  display: inline-block;
  padding: 12px 16px;
  border-left: 4px solid #003da5;
  border-radius: 8px;
  background: #edf3ff;
  color: #1f2f3d;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.7;
}

.reveal {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.8s ease;
}

.reveal.active {
  opacity: 1;
  transform: translateY(0);
}

@media (max-width: 768px) {
  .support-section {
    padding: 40px 0;
  }

  .support-wrapper {
    padding: 0 20px;
  }

  .support-block h1 {
    font-size: 26px;
  }
}
</style>
